import React, { Component } from 'react';
import {Context } from '../../context/context';
import * as _ from 'lodash';
import * as d3 from 'd3';
import { 
  wrap, 
  getForceSimulation, 
  addMarkerDefs,
  //fisheye0
} from '../../utils/d3-utils';
import { 
  getNodesAndLinks,
  getICModelLinksFromNode
 } from '../../data/DataUtils';
import { 
  FACTOR_ICONS,
  FACTOR_ICON_SIZE,
  FACTOR_NAME_SPLIT_STRING,
  HIGHLIGHT_ORIGIN_LEGEND,
  NODE_MENU_BOX,
  FACTOR_SPECIALIZATION_ADAPTATION,
  FACTOR_SPECIALIZATION_EXPOSURE,
  FACTOR_SPECIALIZATION_HAZARD,
  FACTOR_SPECIALIZATION_IMPACT,
  FACTOR_SPECIALIZATION_RISK,
  FACTOR_SPECIALIZATION_VULNERABILITY,
  OPACITY_OFF,
  OPACITY_ON
} from '../../Constants';
import {
  addSelectedIcon,
  removeSelectedFactor
} from './ICNetwork-functions';
import NetworkLegend from './NetworkLegend';
import { addFactor } from "../../utils/url-utils";


class ICNetwork extends Component {

  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      relatedFactors: []
    };
  }


  componentDidUpdate(prevProps, prevState) {
    let {
      highlightedFactorType,
      highlightedFactorSubtype,
      highlightOrigin,
      factorNameSearch,
      resetZoomFlag,
      resetZoom,
      zoom,
      factorsInContext,
      isFactorSelected,
      isFactorANeighbourOfSelectedFactor,
      onlySelectedFactorsVisible,
      selectedFactors
    } = this.context;

    if(
      !_.isEqual(
        this.props.rejectedFactorTypes, 
        prevProps.rejectedFactorTypes
      ) || 
      !_.isEqual(
        this.props.rejectedFactorSubTypes, 
        prevProps.rejectedFactorSubTypes
      ) ||
      !_.isEqual(
        this.props.clusteredNetworkLayout,
        prevProps.clusteredNetworkLayout
      ) ||
      !_.isEqual(
        this.props.ICModelName,
        prevProps.ICModelName
      )/* ||
      !_.isEqual(
        this.props.selectedFactors,
        prevProps.selectedFactors
      )*/
    ) {
      this.renderICNetwork();
    }
    else {
      // highligh items if user is hovering legend items
      d3.select('.chart')
        .selectAll('g.node')                     
        .classed('highlighted', d =>  { 

          return ((highlightOrigin === HIGHLIGHT_ORIGIN_LEGEND) && 
          (
            (
              // check if there is any element from the legend being hovered
              (
                _.isNil(highlightedFactorSubtype)?
                    _.isEqual(d.data.factorTypeName, highlightedFactorType) 
                    :
                    _.isEqual(d.data.factorSubtypeName, highlightedFactorSubtype)           
              )
            )                        
            ) || 
            // check if there is text in the legend text search
            (
              !_.isEmpty(factorNameSearch) && (
                _.lowerCase(d.data.factorName).includes(_.lowerCase(factorNameSearch)) ||
                _.lowerCase(factorsInContext[d.data.factorName]?.contextualDescription).includes(_.lowerCase(factorNameSearch))
              )
            )
          );}
        )

      // mark selected items
      d3.select('.chart')
        .selectAll('g.node')
        .select('text')
        // set selected state when needed
        .classed('selected', d => isFactorSelected(d))
      
      // update selected icon on items
      d3.select(".chart")
        .selectAll('g.node')
        .each(function(d) {
          if(isFactorSelected(d)) {
            addSelectedIcon(d3.select(this));
            d3.select(this).select('.menubox').select('.MenuLess').raise();
          }
          else
            removeSelectedFactor(d3.select(this));        
        });

      d3.selectAll(".link")
        .classed("selected", (d) => !_.isEmpty(
          _.intersection(
            [d.source.label, d.target.label], 
            _.map(selectedFactors,'label')
          )
        )
      );

      // if needed, just show only selected factors and links
      if(onlySelectedFactorsVisible) {
        d3.select('.chart')
          .selectAll('g.node')
          .attr(
            'opacity', 
            d => isFactorSelected(d) || isFactorANeighbourOfSelectedFactor(d) ? OPACITY_ON:OPACITY_OFF
          );      
        
          d3.selectAll(".link")
          .attr("opacity", (d) => !_.isEmpty(
              _.intersection(
                [d.source.label, d.target.label], 
                _.map(selectedFactors,'label')
              )
            ) ? OPACITY_ON:OPACITY_OFF
          );
      }
      else {
        // only try to show everything again if we are not reaching here
        // from an update becasue of hovering nodes (which only show the hovered
        // node and its neighbours)
        if(_.isUndefined(highlightOrigin)) {
          d3.select('.chart').selectAll('g.node').attr('opacity', OPACITY_ON);
          d3.selectAll(".link").attr("opacity", OPACITY_ON);
        }        
      }            
    } 
    
    if(resetZoomFlag) {
      d3.select('.chart').call(zoom.transform, d3.zoomIdentity);        
      resetZoom(false);
    }
  }



  componentDidMount() {
    this.renderICNetwork();
  }



  renderICNetwork() {    
    let linkLabel;

    const chart = d3.select('.chart');
    
    let {
      ICModelLinks,
      factorsInContext,
      highlightFactorType,
      fetchHoveredFactor,
      selectFactor,
      isFactorSelected,
      fetchLink,
      rejectedFactorTypes,
      rejectedFactorSubTypes,
      clusteredNetworkLayout,
      zoom,
      selectedFactors
    } = this.context,    

    transform = d3.zoomIdentity,

    data = getNodesAndLinks(
        ICModelLinks,
        factorsInContext, 
        rejectedFactorTypes, 
        rejectedFactorSubTypes,
        []
      );

    // functions to define interaction on the network
    let onMouseOver = (d, nodeSelection) => {
      // get node data  
      let node = nodeSelection.datum(),
      // get links containing this node
        links = getICModelLinksFromNode(node.label, ICModelLinks),    
        // get all node labels from links containing the hovered node.
        // if there are no links, an isolated node is being hovered
        nodesLabelsInLinks = _.isEmpty(links) ? [node.label] : _(links)
          .keys()
          .map(key => key.split(FACTOR_NAME_SPLIT_STRING))
          .flatten()
          .uniq()
          .value();

      nodeSelection.classed('highlighted', true);   
      
      highlightFactorType(node.data.factorTypeName, node.data.factorSubtypeName, 'network');

      // highlight related nodes
      chart.selectAll('.node')
        .attr('font-weight', function(d) { 
          return setFontWeight(d, nodesLabelsInLinks)
        })
        .attr('opacity', function(d) { 
          return setOpacity(d, nodesLabelsInLinks)
        });

      // highlight related links
      chart.selectAll(".link")
        .attr('marker-start', function(d) {
          return linkBelongsToNode(d, links) && node.label === d.target.label? 'url(#arrowhead-start)' : null  
        })
        .attr('marker-end', function(d) {
          return linkBelongsToNode(d, links) && node.label === d.source.label? 'url(#arrowhead-end)' : null  
        })
        .attr("opacity", function(d) {
          return linkBelongsToNode(d, links)? OPACITY_ON : OPACITY_OFF;
        });
        /*.attr('stroke-width', function(d) {
          return linkBelongsToNode(d, links)? 4:1;
        })*/;

      // get links used in the network
      let activeLinks = _(links)
        .keys()
        .map(key => {
          let nodeLabels = key.split(FACTOR_NAME_SPLIT_STRING);
          return _.find(
            data.links, 
            l => l.source.label === _.first(nodeLabels) && l.target.label === _.last(nodeLabels)
          );
        })
        .compact()
        .value()

      // add type of link between each pair of related nodes 
      linkLabel.selectAll('.link-label').remove();
      linkLabel.selectAll('.link-label')
        .data(activeLinks).enter()
        .append('text')
        .attr('class', 'link-label')
        .attr('text-anchor', 'middle')
        .attr('x', function(d) {
          let xs = [d.source.x, d.target.x].sort();
          return (xs[0] + (xs[1] - xs[0])/2);              
        })
        .attr('y', function(d) {
          let ys = [d.source.y, d.target.y].sort();
          return (ys[0] + (ys[1] - ys[0])/2);
        })
        .text(function(d) {
          return _.replace(
            _.kebabCase(
              _.find(d.type, type => type.factorName === node.label)?.linkType
            ),
            RegExp("-","g"), 
            ' '
          )
        });
      
      nodeSelection.raise();
    };

    let onMouseOut = (d, nodeSelection) => {
      // remove link labels
      chart.selectAll('.link-label').remove();

      nodeSelection.classed('highlighted', false);
      highlightFactorType();

      chart.selectAll(".link")
        .attr('opacity', 1)
        .attr('marker-start', null)
        .attr('marker-end', null);
      chart.selectAll('.node')
        .attr('opacity', 1)
        .attr('font-weight', 'normal');
      //chart.selectAll('.link-label').remove();

      nodeSelection.select('.menubox').style('visibility', 'hidden');
    };

    // clean svg
    chart.selectAll("g").remove();
    
    // add marker defs in svg to display directionality in links
    addMarkerDefs(chart);
    
    let svgSize = d3.select('.svg-wrapper').node().getBoundingClientRect();

    // adjust available size for the network:
    // - div .svg-wrapper reaches the end of the page, substract footer's height from the available height
    // - nodes have labels on its right side, and network occupied space is calculated based only on node´s positions, 
    //   so accomodate a bit more of horizontal space for them: NOT in the svg size, but on the size we pass to the force simulation
    svgSize.height -= d3.select('footer.footer').node().getBoundingClientRect().height;
    
    // when there is an IC already present but user select a new IC, we render
    // by being aware of a change in ICModelname, which is updated in the view
    // of IC selection. However, network is hidden by that time, so avoid
    // rendering when the network is not visible
    if(svgSize.height <= 0 || svgSize.width <= 0)
      return;

    chart
      .attr('width', svgSize.width)
      .attr('height', svgSize.height)
      .attr('viewbox', [-svgSize.width/2, -svgSize.height/2, svgSize.width, svgSize.height])
      .attr("style", "max-width: 100%;");

    //Initializing force simulation
    let simulation = getForceSimulation(
      data, 
      svgSize.width * 0.9, // 0.9 : refer to the comment above on available size for the network 
      svgSize.height, 
      clusteredNetworkLayout
    );

    // helper functions for setting attrs in d3 selections
    const linkBelongsToNode = (d, links) => _.has(links, [d.source.label, d.target.label].join(FACTOR_NAME_SPLIT_STRING)),
          setOpacity = (d, nodesLabelsInLinks) => nodesLabelsInLinks.includes(d.label) ? OPACITY_ON : OPACITY_OFF,
          setFontWeight = (d, nodesLabelsInLinks) => nodesLabelsInLinks.includes(d.label) ? 'normal' : 'normal';

    // Creating nodes, links and link labels: order is important to avoid overlapping issues
    
    // Creating links
    const link = chart.append('g')
      .attr("class", "link-container")
      // this transform is needed to keep the graph centered (same in links and nodes)
      .attr("transform", `translate(${svgSize.width/2}, ${svgSize.height/2})`)
      .selectAll('line')
      .data(data.links, d => d.index).enter()
      .append('line')
      .attr("id", d => [d.source.label, d.target.label].join(FACTOR_NAME_SPLIT_STRING))
      .attr('class', 'link')
      .on('mouseover', (e, d) => fetchLink(d.source.label, d.target.label) )
      .on('mouseleave', () => fetchLink())
      .classed("selected", (d) => !_.isEmpty(
          _.intersection(
            [d.source.label, d.target.label], 
            _.map(selectedFactors,'label')
          )
        )
      );

    // Creating link labels
    linkLabel = chart.append('g')
      // this transform is needed to keep the graph centered (same in links and nodes)
      .attr("transform", `translate(${svgSize.width/2}, ${svgSize.height/2})`)
      .attr('class', 'link-label-container')

    // Creating nodes
    const node = chart.append('g')
      .attr("class", "node-container")
      .attr("transform", `translate(${svgSize.width/2}, ${svgSize.height/2})`)
      .selectAll('g')
      .data(data.nodes)
      .join('g')
      .attr('class', 'node');

    // add contextual menu to the factor
    let nodeMenu = node.append('g')
      .attr('class', 'menubox')
      .attr('transform', `scale(1.25) translate(${-NODE_MENU_BOX}, ${-FACTOR_ICON_SIZE*2.2})`);
    nodeMenu.append('rect')
      .attr('width', NODE_MENU_BOX*1.2)
      .attr('height', FACTOR_ICON_SIZE*4)
    nodeMenu.append('path')
      .attr('d', 'M 0 0 L 70 0 L 70 27 L 60 20 L 0 20 Z')

    // if factor selected, add selected icon
    // and put the unselect icon upfront
    node.each(function(d) {
      if(isFactorSelected(d)) {
        addSelectedIcon(d3.select(this));
        d3.select(this).select('.menubox').select('.MenuLess').raise();
      }
    });

    node
      .append('g')
      // this transform is needed to keep the graph centered (same in links and nodes)
      .attr("transform", d => `translate(${-FACTOR_ICON_SIZE/2},${-FACTOR_ICON_SIZE/2})`)
      .append('svg')
      .append('use')
      .attr('xlink:href', d => `#${d.type}`);
      
    node.append("text")
      .attr("transform", `translate(${FACTOR_ICON_SIZE*0.7},0)`)
      .attr("dx", 0)
      .attr("dy", 0)
      .classed("selected", d => isFactorSelected(d))
      .text(d => _.truncate(d.label, 75))

    node.selectAll("text").call(wrap, 70, 0)

    node
      .on('mouseover', function(event, d) {
        fetchHoveredFactor(d.label)
        onMouseOver(d, d3.select(this));
      })
      .on('mouseleave', function(d) {      
        fetchHoveredFactor()
        onMouseOut(d, d3.select(this));
      })
      .on('click', function(event, d) {    
        let func  = isFactorSelected(d)? removeSelectedFactor : addSelectedIcon;
        func(d3.select(this));        
        // add / remove selected factor in the state
        selectFactor(d);
        // add / remove factor in the URL params
        addFactor(d.data.factorShortId);
      });

    //Setting location when ticked
    const ticked = () => {
      link
        .attr("x1", d => { return d.source.x; })
        .attr("y1", d => { return d.source.y; })
        .attr("x2", d => { return d.target.x; })
        .attr("y2", d => { return d.target.y; });
      node.attr("transform", d => `translate(${d.x},${d.y})`);
    }
        
    chart.call(
      zoom
        .scaleExtent([1/2, 64])
        .on("zoom", function(event) {      
          transform = event.transform;
          // how node and link containers have already a transform, mantain them considering
          // the current zoom scale 
          let x = transform.x + (transform.k * (svgSize.width/2)),
            y = transform.y + (transform.k * (svgSize.height/2));
          chart
            .selectAll(".node-container,.link-container,.link-label-container")
            .attr("transform", d => `translate(${x},${y}) scale(${transform.k})`);    
        }
      )
    );

    for (var i = 1200; i > 0; --i) simulation.tick();
    simulation.on("tick", ticked);
    ticked();
  }

  render() {

    return <div className="network">
      <div className='svg-wrapper'>
        <svg className='chart' id="impact-chain-network">
          {
            _.keys(FACTOR_ICONS)
            .map((factorType, i) => <symbol key={i} id={factorType} viewBox='0 0 16 16' width={16} height={16}>
              {
                (factorType === FACTOR_SPECIALIZATION_ADAPTATION) &&
                <svg width="16" height="16" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.9448 40C31.9905 40 40.9448 31.0457 40.9448 20C40.9448 8.9543 31.9905 0 20.9448 0C9.89913 0 0.944824 8.9543 0.944824 20C0.944824 31.0457 9.89913 40 20.9448 40Z" fill="#8c4829" fillOpacity="0.5"/>
                  <path d="M32.5048 11.8204C32.4648 11.7204 32.3848 11.6404 32.2648 11.6204C32.1648 11.6004 32.0448 11.6204 31.9648 11.7004L28.7448 14.9204L26.1448 14.1204L25.3448 11.5204L28.5648 8.30036C28.5648 8.30036 28.6648 8.12035 28.6448 8.00035C28.6248 7.90035 28.5448 7.80036 28.4448 7.76036C26.7848 7.14036 24.9448 7.16036 23.3048 7.84036C21.6648 8.52035 20.3448 9.80035 19.6248 11.4204C18.9048 13.0404 18.8048 14.8804 19.3848 16.5604L10.0648 26.1604C9.48479 26.7404 9.16479 27.5004 9.16479 28.3204C9.16479 29.1404 9.48479 29.9004 10.0648 30.4804C10.6448 31.0604 11.4048 31.3804 12.2248 31.3804C13.0448 31.3804 13.8048 31.0604 14.3848 30.4804L23.6848 20.8804C25.3648 21.4604 27.2048 21.3804 28.8248 20.6604C30.4448 19.9404 31.7248 18.6204 32.4048 16.9604C33.0848 15.3204 33.1048 13.4804 32.4848 11.8204H32.5048ZM12.3648 30.0004C11.3648 30.0004 10.5648 29.2004 10.5648 28.2004C10.5648 27.2004 11.3648 26.4004 12.3648 26.4004C13.3648 26.4004 14.1648 27.2004 14.1648 28.2004C14.1648 29.2004 13.3648 30.0004 12.3648 30.0004Z" fill="white"/>
                </svg>
              }
              {
                (factorType === FACTOR_SPECIALIZATION_EXPOSURE) &&
                <svg width="16" height="16" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.9451 40.0001C31.9908 40.0001 40.9451 31.0458 40.9451 20.0001C40.9451 8.95443 31.9908 0.00012207 20.9451 0.00012207C9.89937 0.00012207 0.945068 8.95443 0.945068 20.0001C0.945068 31.0458 9.89937 40.0001 20.9451 40.0001Z" fill="#cfcf15"/>
                  <path d="M20.8244 12.2401C17.9644 15.1001 16.6844 18.9601 16.9844 22.7001C17.0444 23.5201 17.7044 24.1801 18.5244 24.2401C22.2644 24.5401 26.1244 23.2601 28.9844 20.4001C31.8444 17.5401 33.1244 13.6801 32.8244 9.94014C32.7644 9.12014 32.1044 8.46014 31.2844 8.40014C27.5444 8.10014 23.6844 9.38014 20.8244 12.2401Z" fill="white"/>
                  <path d="M14.5249 34.9201C13.7049 34.9201 13.0249 34.2401 13.0249 33.4201V31.4201C13.0249 27.9601 14.3849 24.6801 16.8249 22.2401C17.4049 21.6601 18.3649 21.6601 18.9449 22.2401C19.5249 22.8201 19.5249 23.7801 18.9449 24.3601C17.0649 26.2401 16.0249 28.7601 16.0249 31.4201V33.4201C16.0249 34.2401 15.3449 34.9201 14.5249 34.9201Z" fill="white"/>
                  <path d="M15.4845 16.7602C17.1045 18.3802 17.8245 20.5402 17.6445 22.6602C17.6045 23.1202 17.2445 23.5002 16.7845 23.5202C14.6845 23.7002 12.5045 22.9802 10.8845 21.3602C9.26451 19.7402 8.54451 17.5802 8.72451 15.4602C8.76451 15.0002 9.12451 14.6202 9.58451 14.6002C11.6845 14.4202 13.8645 15.1402 15.4845 16.7602Z" fill="white"/>
                </svg>
              }
              {
                (factorType === FACTOR_SPECIALIZATION_HAZARD) &&
                  <svg width="16" height="16" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.9453 40.0001C31.991 40.0001 40.9453 31.0458 40.9453 20.0001C40.9453 8.95443 31.991 0.00012207 20.9453 0.00012207C9.89962 0.00012207 0.945312 8.95443 0.945312 20.0001C0.945312 31.0458 9.89962 40.0001 20.9453 40.0001Z" fill="#2A66FF"/>
                    <path d="M33.7651 26.6401L22.5451 6.28008C21.8451 5.02008 20.0451 5.02008 19.3451 6.28008L8.12512 26.6401C7.46512 27.8601 8.32512 29.3401 9.72512 29.3401H32.1651C33.5451 29.3401 34.4251 27.8601 33.7651 26.6401ZM19.3051 10.9801C19.3051 10.1601 19.9851 9.48008 20.8051 9.48008C21.6251 9.48008 22.3051 10.1601 22.3051 10.9801V20.0401C22.3051 20.8601 21.6251 21.5401 20.8051 21.5401C19.9851 21.5401 19.3051 20.8601 19.3051 20.0401V10.9801ZM20.8051 27.1001C19.7251 27.1001 18.8451 26.2201 18.8451 25.1401C18.8451 24.0601 19.7251 23.1801 20.8051 23.1801C21.8851 23.1801 22.7651 24.0601 22.7651 25.1401C22.7651 26.2201 21.8851 27.1001 20.8051 27.1001Z" fill="white"/>
                  </svg>
              }
              {
                (factorType === FACTOR_SPECIALIZATION_IMPACT) &&
                  <svg width="16" height="16" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.85 35.7C27.7083 35.7 35.7 27.7083 35.7 17.85C35.7 7.99172 27.7083 0 17.85 0C7.99169 0 0 7.99172 0 17.85C0 27.7083 7.99169 35.7 17.85 35.7Z" fill="#404649"/>
                    <path d="M23.3701 6.77002H12.4001C10.8537 6.77002 9.6001 8.02363 9.6001 9.57002V25.73C9.6001 27.2764 10.8537 28.53 12.4001 28.53H23.3701C24.9165 28.53 26.1701 27.2764 26.1701 25.73V9.57002C26.1701 8.02363 24.9165 6.77002 23.3701 6.77002Z" fill="white"/>
                    <path d="M21.4199 23.8599C21.4199 23.8599 21.3899 23.8599 21.3799 23.8599C20.8699 23.8499 20.4099 23.5399 20.1999 23.0699L17.84 17.8499L16.8499 19.9699C16.5399 20.6399 15.7399 20.9299 15.0699 20.6099C14.3999 20.2899 14.11 19.4999 14.43 18.8299L16.6599 14.0799C16.8799 13.6099 17.35 13.3099 17.87 13.3099C18.39 13.3099 18.87 13.6199 19.08 14.0999L21.5099 19.4699L26.62 9.72994C26.96 9.07994 27.77 8.81993 28.43 9.16993C29.08 9.50993 29.34 10.3199 28.99 10.9799L22.61 23.1499C22.38 23.5899 21.9199 23.8699 21.4199 23.8699V23.8599Z" fill="#404649"/>
                  </svg>
              }
              {
                (factorType === FACTOR_SPECIALIZATION_RISK) &&
                  <svg width="16" height="16" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.95431 0 0 8.9543 0 20C0 31.0457 8.95431 40 20 40Z" fill="white"/>
                    <path d="M28.7213 22.4553H11.2787C9.95711 22.4553 8.88574 23.5267 8.88574 24.8483C8.88574 26.1699 9.95711 27.2413 11.2787 27.2413H28.7213C30.0429 27.2413 31.1143 26.1699 31.1143 24.8483C31.1143 23.5267 30.0429 22.4553 28.7213 22.4553Z" fill="#e0472f"/>
                    <path d="M27.0656 13.5809C26.6063 10.3203 23.6349 7.79126 20.0001 7.79126C16.3653 7.79126 13.3939 10.3203 12.9346 13.5809L10.8535 23.6348H29.1523L27.0713 13.5809H27.0656Z" fill="#e0472f"/>
                    <path d="M16.2178 28.761C16.2178 28.761 16.2178 28.7723 16.2178 28.778C16.2178 30.8704 17.9133 32.5659 20.0057 32.5659C22.0981 32.5659 23.7936 30.8704 23.7936 28.778C23.7936 28.7723 23.7936 28.7667 23.7936 28.761H16.2291H16.2178Z" fill="#e0472f"/>
                    <path d="M20.4878 6.03906H19.5125C18.8611 6.03906 18.333 6.56714 18.333 7.21854V8.44338C18.333 9.09479 18.8611 9.62285 19.5125 9.62285H20.4878C21.1392 9.62285 21.6673 9.09479 21.6673 8.44338V7.21854C21.6673 6.56714 21.1392 6.03906 20.4878 6.03906Z" fill="#e0472f"/>
                  </svg>
              }
              {
                (factorType === FACTOR_SPECIALIZATION_VULNERABILITY) &&
                  <svg width="16" height="16" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.9451 40.0001C31.9908 40.0001 40.9451 31.0458 40.9451 20.0001C40.9451 8.95443 31.9908 0.00012207 20.9451 0.00012207C9.89937 0.00012207 0.945068 8.95443 0.945068 20.0001C0.945068 31.0458 9.89937 40.0001 20.9451 40.0001Z" fill="#2fe09c"/>
                    <path d="M12.0055 22.1201H18.4455L16.5655 33.2401C16.5055 33.6201 16.6055 34.0001 16.8455 34.2801C17.0855 34.5601 17.4655 34.7201 17.8255 34.7201C18.2055 34.7201 18.5655 34.5401 18.7855 34.2401L29.5255 20.5201C29.7255 20.2801 29.8255 19.9601 29.7855 19.6401C29.7655 19.3201 29.6255 19.0201 29.3855 18.8201C29.1455 18.6001 28.8455 18.4801 28.5255 18.4801H22.0855L23.9655 7.36013C24.0255 6.98013 23.9255 6.60013 23.6855 6.32013C23.4455 6.04013 23.0655 5.88013 22.7055 5.88013C22.3255 5.88013 21.9655 6.06013 21.7455 6.36013L11.0055 20.0801C10.8055 20.3401 10.7055 20.6401 10.7455 20.9601C10.7655 21.2801 10.9055 21.5801 11.1455 21.7801C11.3855 22.0001 11.6855 22.1201 12.0055 22.1201Z" fill="white"/>
                  </svg>
              }   
              </symbol>
            )
          }
          <symbol id='MenuPlus' viewBox='0 0 16 16' width={16} height={16}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0066ff" className="bi bi-plus-circle" viewBox="0 0 16 16">
              <rect width='16' height='16'/>
              <path fill='white' d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path fill='white' d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>            
          </symbol>
          <symbol id='MenuLess' viewBox='0 0 16 16' width={16} height={16}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0066ff" className="bi bi-plus-circle" viewBox="0 0 16 16">
              <rect width='16' height='16'/>
              <path fill="white" d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path fill="white" d="M 7.5 7.5 L 8.5 7.5 L 11.5 7.5 C 11.885 7.5 12.125 7.917 11.933 8.25 C 11.844 8.405 11.679 8.5 11.5 8.5 L 8.5 8.5 L 7.5 8.5 L 4.5 8.5 C 4.115 8.5 3.875 8.083 4.067 7.75 C 4.156 7.595 4.321 7.5 4.5 7.5 L 7.5 7.5 Z"/>
            </svg>            
          </symbol>
          <symbol id='MenuInfo' viewBox='0 0 16 16' width={16} height={16}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0066ff" className="bi bi-info-circle" viewBox="0 0 16 16">
              <rect width='16' height='16'/>
              <path fill='white' d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path fill='white' d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg>
          </symbol>
          <symbol id='MenuShare' viewBox='0 0 16 16' width={16} height={16}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0066ff" className="bi bi-share-fill" viewBox="0 0 16 16">
              <rect width='16' height='16'/>
              <path fill='white' d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
          </svg>
          </symbol>
          <symbol id='FactorSelected' viewBox='0 0 16 16' width={16} height={16}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0066ff" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
          </symbol>
        </svg>
      </div>
      
      <div className="network-legend bg-light">
        <NetworkLegend/>
      </div>
    </div>
  }  
}

export default ICNetwork;